

export const CkEditorConfig = {
    toolbar: {
        items: [
            'heading', '|',
            'fontSize', 'fontFamily', '|',
            'bold', 'italic', 'underline', 'strikethrough', 'code', 'subscript', 'superscript', '|',
            'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify', '|',
            'highlight', '|',
            'link',
            'bulletedList',
            'numberedList',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            '|',
            'undo',
            'redo',
            '|',
            'MathType',
            'ChemType'
        ]
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'en'
};

export const CkEditorConfigWithOutMath = {
    toolbar: {
        items: [
            'heading', '|',
            'fontSize', 'fontFamily', '|',
            'bold', 'italic', 'underline', 'strikethrough', 'code', 'subscript', 'superscript', '|',
            'alignment:left', 'alignment:right', 'alignment:center', 'alignment:justify', '|',
            'highlight', '|',
            'link',
            'bulletedList',
            'numberedList',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            '|',
            'undo',
            'redo',
        ]
    },
    table: {
        contentToolbar: [
            'tableColumn',
            'tableRow',
            'mergeTableCells'
        ]
    },
    removePlugins: ['MathType'],
    // This value must be kept in sync with the language defined in webpack.config.js.
    language: 'en'
};

